import { IconArrowRight } from '@tabler/icons-react'
import { Button } from '~/components/Button'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { pluralize } from '~/helpers/pluralize'
import { ListItemProps } from './CustomerListsDrawerDrawer.types'

export const ListItem = ({ list, onClickDetail }: ListItemProps) => {
  return (
    <div className='flex justify-between'>
      <div className='text-primary-blue'>
        <Typography
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyRegularBold}
          className='mb-2'>
          {list?.title || list?.name}
        </Typography>
        <Typography
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyRegular}>
          {pluralize(list?.lineItems?.length || 0, 'item')}
        </Typography>
      </div>
      <Button
        className='text-primary-blue'
        type='button'
        onClick={onClickDetail}
        variant='ghost'>
        <IconArrowRight size={24} strokeWidth={2} className='inline-block' />
      </Button>
    </div>
  )
}
